import {
  menu_styles_default
} from "./chunk.OOBHJM3H.js";
import {
  menuItemSelectors
} from "./chunk.QHZ3R2SE.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  hasFocusVisible
} from "./chunk.ZLFKGBZ6.js";
import {
  HasSlotController,
  getTextContent
} from "./chunk.CLKP6Z3C.js";
import {
  hasTag
} from "./chunk.UFU6LZT7.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  i,
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/menu/menu.ts
import { t as t2 } from "i18next";
var FadvMenu = class extends s {
  constructor() {
    super(...arguments);
    this.hasSlot = new HasSlotController(this, "[default]", "search");
    this.shouldRenderSearch = false;
    this.numberOfSelectedCheckboxes = 0;
    this.hasCategories = false;
    this.orientation = "vertical";
    this.scrollable = false;
    this.typeToSelectString = "";
  }
  firstUpdated() {
    this.setAttribute("role", "menu");
  }
  getAllItems(options = { includeDisabled: true, includeHidden: true }) {
    var _a;
    const menuItems = ((_a = this.defaultSlot) == null ? void 0 : _a.assignedElements({ flatten: true })) || [];
    return menuItems.filter((el) => {
      var _a2;
      const menuItem = el;
      const menuItemTagName = menuItem.tagName.toLowerCase();
      const menuItemRoleAttribute = ((_a2 = menuItem.getAttribute("role")) == null ? void 0 : _a2.toLowerCase()) || "";
      if (!menuItemSelectors.includes(menuItemTagName) && !["menuitem", "menuitemcheckbox"].includes(menuItemRoleAttribute)) {
        return false;
      }
      if (!options.includeHidden && menuItem.style.display === "none") {
        return false;
      }
      if (!options.includeDisabled && menuItem.disabled) {
        return false;
      }
      return true;
    });
  }
  getSearch() {
    var _a;
    const slottedChildren = ((_a = this.searchSlot) == null ? void 0 : _a.assignedElements({ flatten: true })) || [];
    return slottedChildren.find((e2) => hasTag(e2, "fadv-search"));
  }
  syncMenuItems(items) {
    items.forEach((menuItem) => {
      menuItem.classList.toggle("menu-horizontal--menu-item", this.orientation === "horizontal");
      menuItem.classList.toggle("submenu--menu-item", this.slot === "submenu");
      if (hasTag(menuItem, "fadv-menu-category")) {
        this.hasCategories = true;
      }
    });
  }
  connectedCallback() {
    super.connectedCallback();
    this.updateComplete.then(() => {
      this.syncMenuItems(this.getAllItems({ includeDisabled: true, includeHidden: true }));
    });
  }
  handleSlotChange() {
    const items = this.getAllItems({ includeDisabled: true, includeHidden: true });
    const firstItem = items.find((item) => !item.disabled && item.style.display !== "none");
    if (firstItem) {
      this.setCurrentItem(firstItem);
    }
    this.syncMenuItems(items);
    this.shouldRenderSearch = this.determineShouldShowSearchInput(items);
  }
  determineShouldShowSearchInput(items) {
    let numberOfMenuItems = 0;
    for (const element of items) {
      if (menuItemSelectors.includes(element.tagName.toLowerCase()) && !hasTag(element, "fadv-menu-category")) {
        numberOfMenuItems++;
      }
      if (numberOfMenuItems >= 10) {
        return true;
      }
    }
    return false;
  }
  handleCheckboxSelection() {
    let counter = 0;
    const items = this.getAllItems({ includeDisabled: false, includeHidden: false });
    items.forEach((item) => {
      if (hasTag(item, "fadv-menu-category")) {
        const category = item;
        category.updateStateOfMenuItems();
      }
      if (item.checked) {
        counter++;
      }
    });
    this.numberOfSelectedCheckboxes = counter;
  }
  clearSearchHighlight() {
    const menuItems = this.getAllItems();
    for (const m of menuItems) {
      const menuItem = m;
      menuItem.style.display = "unset";
      this.removeSearchHighlight(menuItem);
    }
    this.handleCheckboxSelection();
  }
  removeSearchHighlight(menuItem) {
    menuItem.innerHTML = menuItem.innerHTML.replace('<strong class="search">', "");
    menuItem.innerHTML = menuItem.innerHTML.replace("</strong>", "");
  }
  highlightSearch(menuItem, searchTerm) {
    if (menuItem.textContent && searchTerm !== "") {
      const menuHtml = menuItem.innerHTML;
      const textContentStart = menuHtml.indexOf(menuItem.textContent);
      const textContentEnd = textContentStart + menuItem.textContent.length;
      const start = menuHtml.substring(0, textContentStart - 1);
      const end = menuHtml.substring(textContentEnd);
      const searchStart = menuHtml.toLowerCase().indexOf(searchTerm);
      const searchEnd = searchStart + searchTerm.length;
      const wordStart = menuHtml.substring(0, searchStart);
      const searchPart = menuHtml.substring(searchStart, searchEnd);
      const wordEnd = menuHtml.substring(searchEnd);
      const search = `${wordStart}<strong class="search">${searchPart}</strong>${wordEnd}`;
      menuItem.innerHTML = `${start}${search}${end}`;
    }
  }
  handleSearch(event) {
    var _a, _b;
    const menuItems = this.getAllItems();
    let currentCategory;
    let count = 0;
    this.clearSearchHighlight();
    if (event.detail.query === "") {
      return;
    }
    for (const menuItem of menuItems) {
      if (hasTag(menuItem, "fadv-menu-category")) {
        currentCategory = menuItem;
        count = 0;
      }
      const searchTerm = event.detail.query.toLowerCase();
      if (!((_b = (_a = menuItem.textContent) == null ? void 0 : _a.toLowerCase()) == null ? void 0 : _b.includes(searchTerm))) {
        menuItem.style.display = "none";
        this.removeSearchHighlight(menuItem);
      } else {
        menuItem.style.display = "unset";
        count++;
        this.highlightSearch(menuItem, searchTerm);
        if (currentCategory) {
          currentCategory.style.display = "unset";
        }
      }
      if (currentCategory)
        currentCategory.count = count;
      menuItem.removeAttribute("tabindex");
    }
    this.handleCheckboxSelection();
  }
  getCurrentItem() {
    return this.getAllItems({ includeDisabled: false, includeHidden: false }).find((i2) => i2.getAttribute("tabindex") === "0");
  }
  handleKeyDown(event) {
    if (event.key === "Enter") {
      const item = this.getCurrentItem() || event.target;
      event.preventDefault();
      event.stopImmediatePropagation();
      if ("handleClick" in item) {
        const menuItem = item;
        menuItem.handleClick(event);
        if (menuItem.hasSubmenu) {
          menuItem.handleSubmenuSelection();
        }
      }
      this.handleCheckboxSelection();
      item.click();
    }
    if (event.key === " ") {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    if (["ArrowLeft", "ArrowRight", "ArrowDown", "ArrowUp", "Home", "End"].includes(event.key)) {
      this.handleArrowKey(event);
    }
    this.typeToSelect(event);
  }
  handleArrowKey(event) {
    const items = this.getAllItems({ includeDisabled: false, includeHidden: false });
    if (!items.length)
      return;
    const { key } = event;
    event.preventDefault();
    event.stopImmediatePropagation();
    const activeItem = this.getCurrentItem();
    let index = activeItem ? items.indexOf(activeItem) : -1;
    if (key === "ArrowDown" && this.orientation === "vertical" || key === "ArrowRight" && this.orientation === "horizontal") {
      index++;
    } else if (key === "ArrowUp" && this.orientation === "vertical" || key === "ArrowLeft" && this.orientation === "horizontal") {
      index--;
    } else if (key === "Home") {
      index = 0;
    } else if (key === "End") {
      index = items.length - 1;
    }
    this.handleSubmenuArrowKey(key, index);
    if (index < 0) {
      index = 0;
    }
    if (index > items.length - 1) {
      index = items.length - 1;
    }
    let item = items[index];
    this.handleSubmenuItemArrowKey(key, item);
    item = items[index];
    this.setCurrentItem(item);
    item.focus();
  }
  handleSubmenuArrowKey(key, index) {
    if (this.slot !== "submenu")
      return;
    if (key === "ArrowUp" && index < 0 || key === "ArrowLeft") {
      emit(this, "submenu-close", { detail: { key } });
    }
  }
  handleSubmenuItemArrowKey(key, item) {
    if (!(item == null ? void 0 : item.hasSubmenu))
      return;
    if (key === "ArrowDown" && this.orientation === "horizontal") {
      item.handleSubmenuSelection();
    }
    if (key === "ArrowRight" && this.orientation === "vertical") {
      item.handleSubmenuSelection();
    }
  }
  setCurrentItem(item) {
    const items = this.getAllItems({ includeDisabled: false, includeHidden: false });
    const activeItem = item.disabled || item.tagName.toLowerCase() === "slot" ? items[0] : item;
    items.forEach((i2) => {
      i2.setAttribute("tabindex", i2 === activeItem ? "0" : "-1");
    });
  }
  typeToSelect(event) {
    var _a;
    const items = this.getAllItems({ includeDisabled: false, includeHidden: false });
    clearTimeout(this.typeToSelectTimeout);
    this.typeToSelectTimeout = window.setTimeout(() => this.typeToSelectString = "", 750);
    if (event.key === "Backspace") {
      if (event.metaKey || event.ctrlKey) {
        this.typeToSelectString = "";
      } else {
        this.typeToSelectString = this.typeToSelectString.slice(0, -1);
      }
    } else {
      this.typeToSelectString += event.key.toLowerCase();
    }
    if (!hasFocusVisible) {
      items.forEach((item) => item.classList.remove("sl-focus-invisible"));
    }
    for (const item of items) {
      const slot = (_a = item.shadowRoot) == null ? void 0 : _a.querySelector("slot:not([name])");
      const label = getTextContent(slot).toLowerCase().trim();
      if (label.startsWith(this.typeToSelectString)) {
        this.setCurrentItem(item);
        item.focus();
        break;
      }
    }
  }
  handleClick(event) {
    var _a;
    if (this.hasSlot.test("search")) {
      (_a = this.getSearch()) == null ? void 0 : _a.reset();
      this.clearSearchHighlight();
    }
    const target = event.target;
    const item = target.closest("fadv-menu-item") || target.closest("fadv-menu-item-link") || target.closest("fadv-menu-item-checkbox") || target.closest("fadv-menu-category");
    if ((item == null ? void 0 : item.disabled) === false) {
      emit(this, "sl-select", { detail: { item } });
    }
    this.handleCheckboxSelection();
  }
  handleKeyUp() {
    if (!hasFocusVisible) {
      const items = this.getAllItems();
      items.forEach((item) => {
        item.classList.remove("sl-focus-invisible");
      });
    }
  }
  handleMouseDown(event) {
    const target = event.target;
    if (target.getAttribute("role") === "menuitem" || target.getAttribute("role") === "menuitemcheckbox") {
      this.setCurrentItem(target);
      if (!hasFocusVisible) {
        target.classList.add("sl-focus-invisible");
      }
    }
  }
  renderScroll(template) {
    if (this.scrollable || this.hasSlot.test("search") && this.shouldRenderSearch) {
      return $`<fadv-scroller class=${o({
        "menu-category__scroller": this.orientation !== "horizontal" && this.hasCategories
      })} mode="opaque" >${template}</fadv-scroller>`;
    }
    return template;
  }
  render() {
    const interior = $`<div part="base" @click=${this.handleClick} class=${o({
      menu: true,
      "menu--horizontal": this.orientation === "horizontal"
    })} @keydown=${this.handleKeyDown} @keyup=${this.handleKeyUp} @mousedown=${this.handleMouseDown} ><slot class="menu__container" @slotchange=${this.handleSlotChange} @sl-select=${this.handleCheckboxSelection}></slot></div>`;
    const hasSearch = this.hasSlot.test("search") && this.shouldRenderSearch;
    return $`<div class=${o({
      "menu--wrapper": true,
      "menu--has-search": hasSearch,
      "menu--has-select-label": hasSearch && this.hasCategories
    })} ><div class="menu__search"><slot name="search" @fadv-search-submitted=${this.handleSearch}></slot></div><div class="menu__label"><fadv-typography type="label-xx-small" variant="gray" scale="700" >${t2("components:menu.selected", {
      numberOfSelectedCheckboxes: this.numberOfSelectedCheckboxes
    })}</fadv-typography></div>${this.renderScroll(interior)}</div>`;
  }
};
FadvMenu.styles = menu_styles_default;
__decorateClass([
  t()
], FadvMenu.prototype, "shouldRenderSearch", 2);
__decorateClass([
  t()
], FadvMenu.prototype, "numberOfSelectedCheckboxes", 2);
__decorateClass([
  t()
], FadvMenu.prototype, "hasCategories", 2);
__decorateClass([
  e({ reflect: true })
], FadvMenu.prototype, "orientation", 2);
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvMenu.prototype, "scrollable", 2);
__decorateClass([
  i(".menu")
], FadvMenu.prototype, "menu", 2);
__decorateClass([
  i("slot.menu__container")
], FadvMenu.prototype, "defaultSlot", 2);
__decorateClass([
  i('slot[name="search"]')
], FadvMenu.prototype, "searchSlot", 2);
FadvMenu = __decorateClass([
  n("fadv-menu")
], FadvMenu);

export {
  FadvMenu
};
